<template>
  <Layout :tituloPagina="tituloPagina">
    <div>
      <div class="row mb-4">
        <div class="col-lg-6">
          <barra-paneles
            v-on:panel-seleccionado="actualizarPanel"
            :idCliente="idCliente"
            :tienePermiso="tienePermiso"
          ></barra-paneles>
        </div>
        <div class="col-lg-6 mt-3">
          <cmp-opciones-reportes
            v-if="idCliente != 901 && idCliente != 902"
            :panel-activo="panel"
            :id-cliente="idCliente"
            :nombre-cliente="nombreCliente()"
            :telefonos-cliente="telefonosCliente()"
          ></cmp-opciones-reportes>
        </div>
      </div>

      <div v-if="panel == 'informacion'">
        <div class="row">
          <div class="col-xxl-3">
            <cmp-informacion-cliente
              :id-cliente="idCliente"
              v-if="idCliente != 901 && idCliente != 902"
              :cargarAliasCampo="cargarAliasCampo"
              :tieneAlias="tieneAlias"
              @cliente-cargado="actualizarDatosCliente"
            ></cmp-informacion-cliente>
          </div>

          <div class="col-xxl-9">
            <div class="row">
              <div class="col-xl-4 col-lg-6">
                <cmp-cobro-pendiente
                  :id-cliente="idCliente"
                ></cmp-cobro-pendiente>
              </div>
              <div class="col-xl-4 col-lg-6">
                <cmp-ultimo-pago
                  :id-cliente="idCliente"
                ></cmp-ultimo-pago>
              </div>
              <div class="col-xl-4">
                <cmp-abono-sin-asignar
                  :id-cliente="idCliente"
                ></cmp-abono-sin-asignar>
              </div>
            </div>

            <cmp-contratos
              :id-cliente="idCliente"
              v-if="idCliente != 901 && idCliente != 902"
            ></cmp-contratos>

            <div class="text-end">
              <button class="btn btn-secondary" @click="atras()">
                <i class="mdi mdi-chevron-left"></i>
                Atras
              </button>
            </div>
          </div>
        </div>
      </div>      

      <div v-if="panel == 'facturas'" >
        <cmp-panel-facturas
          :id-cliente="idCliente"
          :nombre-completo-cliente="nombreCompletoCliente"
        ></cmp-panel-facturas>
      </div>
      
      <div v-if="panel == 'pagos'">
        <cmp-panel-pagos
          :id-cliente="idCliente"
        ></cmp-panel-pagos>
      </div>
      
      <div v-if="panel == 'reportes' && idCliente != 901 && idCliente != 902">
        <cmp-panel-reportes
          :id-cliente="idCliente"
        ></cmp-panel-reportes>
      </div>
    </div>
    <br>
  </Layout>
</template>

<script>
import Layout from "@/views/layouts/main.vue"

import BarraPaneles from './BarraPaneles.vue'
import CmpOpcionesReportes from './CmpOpcionesReportes.vue'
import CmpCobroPendiente from './CmpCobroPendiente.vue'
import CmpUltimoPago from './CmpUltimoPago.vue'
import CmpAbonoSinAsignar from './CmpAbonoSinAsignar.vue'
import CmpInformacionCliente from './CmpInformacionCliente.vue'
import CmpContratos from './CmpContratos.vue'
import CmpPanelFacturas from './CmpPanelFacturas.vue'
import CmpPanelPagos from './CmpPanelPagos.vue'
import CmpPanelReportes from './CmpPanelReportes.vue'
import ClienteSrv from '@/services/ClienteSrv.js'

import { todoGetters } from "@/state/helpers"

export default {
  name: 'TableroCliente',
  components: {
    Layout,
    BarraPaneles,
    CmpOpcionesReportes,
    CmpCobroPendiente,
    CmpUltimoPago,
    CmpAbonoSinAsignar,
    CmpInformacionCliente,
    CmpContratos,
    CmpPanelFacturas,
    CmpPanelPagos,
    CmpPanelReportes
  },
  data() {
    return {
      baseUrl: window.location.origin,
      idCliente: null,
      nombreCompletoCliente: '',
      cliente: {
        id: null,
        nombre: '',
        apellido_paterno: '',
        apellido_materno: '',
        telefonos: [],
        etiquetas: []
      },
      panel: 'informacion',
      cortesServicios: [],
      contratos: []
    }
  },
  created: function() {
    var self = this

    self.idCliente = parseInt(this.$route.params.id_cliente)

    self.cargarNombreCliente()
  },
  computed:{
    ...todoGetters,
    tituloPagina: function() {
      var self = this
      return `Clientes | Tablero ${self.nombreCompletoCliente}`
    }
  },
  methods: {
    actualizarDatosCliente: function(cliente) {
      this.cliente = cliente
    },

    actualizarPanel: function(nombrePanel) {
      this.panel = nombrePanel != '' ? nombrePanel : 'informacion'
    },

    atras: function() {
      this.$router.go(-1)
    },

    cargarNombreCliente: function() {
      var self = this
      ClienteSrv.nombreCompleto(this.$route.params.id_cliente).then(response => {
        self.nombreCompletoCliente = response.data
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (error) {
          mensaje = ''
        }
        mensaje != '' ? iu.msg.error(mensaje):null
        console.log(error)
      })
    },

    nombreCliente: function() {
      var cliente = this.cliente
      let nombre = cliente.nombre

      if(cliente.apellido_paterno) nombre += ' ' + cliente.apellido_paterno
      if(cliente.apellido_materno) nombre += ' ' + cliente.apellido_materno

      return nombre
    },

    mostrarListaCortes: function(cortesServicios) {
      mdlCortes.mostrar(cortesServicios)
    },

    telefonosCliente: function() {
      var cliente = this.cliente
      var cadenaTelefonos = ''

      cliente.telefonos.forEach(function(telefono, index) {
        cadenaTelefonos += telefono.numero
        if (index + 1 < cliente.telefonos.length) cadenaTelefonos += ', '
      })

      return cadenaTelefonos
    }
  },
}
</script>

<style scoped>

</style>